
styles += """
  [data-widget="TestimonialGrid"] .testifier {
    padding: 0px 16px;
    flex: 1;
  } @media (max-width: 374px) { [data-widget="TestimonialGrid"] .testifier {
    padding: 0px 0px 0px 16px;
  }}

  [data-widget="TestimonialGrid"].single .testifier {
    padding: 0;
  }


  [data-widget="TestimonialGrid"] .testimonial.embedded {
    font-weight: 400;
    line-height: 1.5;
    font-size: 16px;
  }

  [data-widget="TestimonialGrid"] .testimonial.embedded strong {
    font-weight: 600;
  }



  [data-widget="TestimonialGrid"] .testifier_name {
    font-size: #{responsive_css_rule({min_size: 18, max_size: 22, min_vw: 450, max_vw: 650})};
    font-weight: 600;
  }
  [data-widget="TestimonialGrid"] .testifier_affiliation {
    font-size: #{responsive_css_rule({min_size: 15, max_size: 18, min_vw: 360, max_vw: 650})};
    color: black;
    font-weight: 600;
    margin-top: 2px;             

  }
  [data-widget="TestimonialGrid"] .testifier_role {
    font-size: #{responsive_css_rule({min_size: 14, max_size: 15, min_vw: 450, max_vw: 650})};
    margin-top: 2px;
  }

  [data-widget="TestimonialGrid"] .testifier_avatar {
    height: #{responsive_css_rule({min_size: 40, max_size: 75, min_vw: 400, max_vw: 500})};
    aspect-ratio: 1/1;
    vertical-align: middle;
    border-radius: 50%;
  }

  [data-widget="TestimonialGrid"] .testifier_name_container {
    position: relative;
    top: 20px;
    padding: 12px #{responsive_css_rule({min_size: 0, max_size: 20, min_vw: 400, max_vw: 500})};
    white-space: nowrap;
  }

  [data-widget="TestimonialGrid"] .testifier_name_wrapper {
    display: inline-block;
    padding: 0 16px;
    padding-right: #{responsive_css_rule({min_size: 0, max_size: 16, min_vw: 374, max_vw: 500})};  
    vertical-align: middle;
  }

  [data-widget="TestimonialGrid"] .quote_bubble {
    padding: 36px 42px;
    position: relative;
    box-shadow: 0px 1px 4px rgba(0,0,0,.3);
    border-radius: 54px;
    flex: 1;
    max-Width: 800px;
  }

  @media (max-width: 868px) {
    [data-testimonial-num="1"] {
      display: none;
    }
  }
  @media (max-width: 1119px) {
    [data-testimonial-num="2"] {
      display: none;
    }
  }


"""

window.TestimonialGrid = ReactiveComponent
  displayName: 'TestimonialGrid'


  render: -> 
    the_testimonials = @props.testimonials
    expanded = @local.expanded 

    if !@props.top?
      top = true 
    else 
      top = @props.top 

    w = Math.min WINDOW_WIDTH(), 520 * the_testimonials.length

    if w < 869
      max_testimonials = 1 
    else if w < 1120
      max_testimonials = 2
    else 
      min_pixels_per = 375
      max_testimonials = Math.max 1, w / min_pixels_per

    if max_testimonials < the_testimonials.length 
      the_testimonials = the_testimonials[0..max_testimonials - 1]

    odd = the_testimonials.length % 2 == 1

    user_row = =>
      single = the_testimonials.length == 1

      DIV 
        key: 'user_row'
        style:
          display: 'flex'

        for t, idx in the_testimonials

          DIV 
            key: idx
            "data-testimonial-num": idx
            className: 'testifier'
            style:
              opacity: if expanded && expanded != t then .35

            @user_credentials 
              testimonial: t
              left: (odd || idx < the_testimonials.length / 2)
              top: top
              bg_color: considerit_gray
              right_side: idx > the_testimonials.length / 2

    quote_row = => 

      len = the_testimonials.length
      for t,idx in the_testimonials
        continue if !expanded || expanded != t
        left = idx == 0
        center = len == 3 && idx == 1

      DIV 
        key: 'quote_row'
        style: 
          display: 'flex'
          justifyContent: if expanded then (if left then 'left' else if center then 'center' else 'right')

        for t,idx in the_testimonials
          continue if expanded && expanded != t


          @quote_bubble 
            idx: idx
            key: @local.key
            testimonial: t
            top: top
            bg_color: considerit_gray
            color: 'black'
            italic: @props.italic
            single: len == 1

    DIV 
      className: if the_testimonials.length == 1 then 'single'
      if top 
        [user_row(), quote_row()]
      else 
        [quote_row(), user_row()]



  user_credentials: (opts) ->


    t = opts.testimonial
    expanded = @local.expanded == t
    
    left = opts.left 
    mouth_dir_left = left && !(expanded && opts.right_side)
    top = opts.top 
        
    avatar_and_mouth = => 

      size = if WINDOW_WIDTH() < 400 then 40 else 75
      DIV 
        style: 
          display: 'inline-block'

        if t.avatar
          IMG
            title: t.alt
            className: 'testifier_avatar'
            alt: t.alt or "Image of #{t.name}"
            ref: "avatar-#{t.name.replace(' ', '-')}"
            src: t.avatar

        DIV
          style:
            transform:  if !top 
                          "rotate(180deg) #{if mouth_dir_left then 'scaleX(-1)' else ''}"
                        else 
                          "#{if !mouth_dir_left then 'scaleX(-1)' else ''}"
                          # "scale(#{if left then -1 else 1},-1) #{if left then 'scaleX(-1)' else ''}"

            position: 'absolute'
            left: if left then size / 2 + (if mouth_dir_left then 28 else 0)
            right: if !left then size / 2 + 20
            bottom: if top then -30
            top: if !top then -30
            zIndex: 2

          Bubblemouth 
            apex_xfrac: 0
            width: 30
            height: 30
            fill: opts.bg_color
            stroke: 'transparent'
            stroke_width: 0
            box_shadow:   
              dx: if top then -3 else 3 
              dy: 0
              stdDeviation: if top then 1 else 2
              opacity: if top then .15 else .4



    DIV 
      className: 'testifier_name_container'
      style: 
        float: if !left then 'right' 
        cursor: if t.long_quote then 'pointer'
      onClick: if t.long_quote then (e) => 
        if expanded 
          @local.expanded = null 
        else 
          @local.expanded = t 
        save @local


      if left # && t.avatar 
        avatar_and_mouth()



      DIV 

        className: 'testifier_name_wrapper'
        style:
          textAlign: if !left then 'right'

        DIV 
          className: 'testifier_name'
          style: 
            color: fetch('colors').primary_color
          t.name

        if t.organization
          DIV 
            className: 'testifier_affiliation'
            t.organization

        if t.role
          DIV 
            className: 'testifier_role'
            t.role


      if !left # && t.avatar 
        avatar_and_mouth()



  quote_bubble: (opts) ->
    t = opts.testimonial
    

    expanded = @local.expanded == t

    if expanded
      quote = opts.long_quote or t.long_quote
    else if WINDOW_WIDTH() < 414 && (opts.short_mobile_quote or t.short_mobile_quote)
      quote = opts.short_mobile_quote or t.short_mobile_quote
    else 
      quote = opts.short_quote or t.short_quote

    DIV
      key: opts.idx
      "data-testimonial-num": opts.idx
      className: 'quote_bubble'
      style:
        backgroundColor: opts.bg_color
        marginTop: if top then 20 + 24
        marginBottom: if !top then 20 else 4
        marginRight: if !opts.single then 16 else 4
        marginLeft: if !opts.single then 16 else 4
        color: opts.color

   
      DIV
        className: 'testimonial embedded'
        style: 
          fontStyle: if !expanded && opts.italic then 'italic'

        DIV dangerouslySetInnerHTML: {__html: quote}

      if t.long_quote && !@props.hide_full
        @readmore
          testimonial: t




  readmore: (opts) -> 
    t = opts.testimonial
    
    onclick = => 
      if @local.expanded == t
        @local.expanded = null 
      else 
        @local.expanded = t 
      save @local 


    BUTTON 
      style: 
        backgroundColor: 'transparent'
        border: 'none'
        color: 'black' # primary_color()
        textDecoration: 'underline'
        paddingTop: 12
        paddingLeft: 0
      onClick: onclick
      onKeyPress: (e) => 
        if e.which == 16 || e.which == 32
          e.preventDefault()
          onclick()

      if @local.expanded == t
        "read less from #{t.name.split(' ')[0]}"
      else 
        "read more from #{t.name.split(' ')[0]}"

  componentDidMount: -> 
    # trigger rerender so quote bubble is rendered with positions intact
    @local.dummy = true 
    save @local 


styles += """
blockquote {
  /* background: #f9f9f9; */
  /* border-left: 6px solid #ccc; */
  margin: 1.5em 0px 1.5em 0px;
  padding: 0.5em 26px;
  quotes: initial; /*"\x01C""\x01D""\x018""\x019";*/
  color: #333;
  font-size: 18px;
  line-height: 1.6;
  font-weight: 300;
  font-style: italic;
}

blockquote:before {
  color: #ccc;
  content: open-quote;
  font-size: 4em;
  line-height: 0.1em;
  margin-right: -27px;
  vertical-align: -0.4em;
  position: relative;
  left: -36px;
}

"""

window.TestimonialBlockquote = ReactiveComponent
  displayName: 'TestimonialBlockquote'
  render: ->
    testimonial = @props.testimonial

    DIV 
      className: "blockquote"
      style: 
        maxWidth: 800
        margin: 'auto'

      BLOCKQUOTE 
        dangerouslySetInnerHTML: __html: testimonial.short_quote

      DIV 
        style: 
          display: 'flex'
          justifyContent: 'right'

        if testimonial.avatar
          DIV null,

            IMG
              title: testimonial.alt
              alt: testimonial.alt
              ref: "avatar-#{testimonial.name.replace(' ', '-')}"
              src: testimonial.avatar
              style: 
                height: 40
                width: 40
                verticalAlign: 'middle'   

        DIV 
          style:
            display: 'inline-block'
            padding: '0 16px'
            verticalAlign: 'middle'  

          if testimonial.name 
            DIV 
              style: 
                fontSize: 18
              testimonial.name

          if testimonial.organization
            DIV 
              style: 
                fontSize: 16        
              testimonial.organization

          if testimonial.role
            DIV 
              style: 
                fontSize: 16        
              testimonial.role




window.testimonials = 


  daniel: 
    alt: 'Daniel Reeves uses Consider.it to get feedback about priorities from users of his company\'s product Beeminder'
    name: 'Daniel Reeves, Ph.D.'
    role: 'Co-founder / CEO'
    organization: 'Beeminder'
    avatar: asset('product_page/daniel.png')

    short_quote: """
      <b>Consider.it is a much nicer way to poll opinions and see a consensus emerge than other ways we (Beeminder) know of</b>. 
      So far we've used it for prioritizing features, brainstorming taglines, and for naming things. It's great! 
      And working with Consider.it has been amazing. They're responsive, brilliant, and passionate.
    """

  kehau: 
    alt: "Kēhau Abad uses Consider.it to help organize her community's efforts to lead Hawai’i toward a regenerative future."
    name: 'Kēhau Abad, Ph.D.'
    role: 'Board of Directors' # 'Kealaiwikuamoʻo Director' # "Network of Native Hawaiian Schools director"
    organization: 'ʻĀina Aloha Economic Futures'
    avatar: asset('product_page/kehau.jpg')

    # short_quote: """
    #   The Consider.it record of the robust online conversation we held has proven invaluable. We were able to 
    #   develop a Policy Playbook that spotlighted salient points raised through the proposals and 
    #   the Consider.it discussion of them. <b>Hawai’i state and county policy makers can readily 
    #   see in our Consider.it record that a large community of engaged participants collectively 
    #   arrived at the proposals offered in it, affording the Playbook a significant degree of impact.</b>

    # """

    short_mobile_quote: """
      <p>The momentum our Consider.it dialogue produced contributed in part to 
      the passage of bills on climate change mitigation, sustainable agriculture, raising 
      the minimum wage, and protections 
      for traditional water rights.</p>

    """

    short_quote: """
      <p><a style="font-weight: 400; text-decoration: none;" href="https://ainaalohafutures.consider.it" target="_blank">Our Consider.it record</a> of robust conversation has proven invaluable.</p>

      <p>Hawai’i policy makers can readily see that a 
      large community of engaged participants collectively arrived at the proposals offered in 
      it. It helped us garner 
      <a style="font-weight: 400; text-decoration: none;" href="https://docs.google.com/spreadsheets/d/1WNkdsyhd-whH58dE-6819oFmVVHur0c0V41Rl7fL33E/edit#gid=0" target="_blank">many signatories</a> 
      including three of four county mayors, three of four county councils, the largest private 
      landowner in Hawai’i, and the Hawai’i Tourism Authority.</p>

      <p><b>The momentum our Consider.it dialogue produced contributed in part to 
      the passage of bills on climate change mitigation, sustainable agriculture, raising 
      the minimum wage, and protections 
      for traditional water rights.</b></p> 
      """

    long_quote: """
      <p>
      <a href="https://www.ainaalohafutures.com/" target="_blank">‘Āina Aloha Economic Futures</a> (AAEF) formed 
      in response to the reset opportunity COVID provided us in Hawaiʻi. 
      From spontaneous conversations among like-minded friends arose the idea to organize larger community 
      conversations to set a new course for Hawaiʻi. We drafted 
      <a href="https://www.ainaalohafutures.com/declaration" target="_blank">core values</a>, 
      an <a href="https://www.ainaalohafutures.com/action-agenda" target="_blank">action agenda</a>, and 
      organized <a href="https://www.ainaalohafutures.com/proposals" target="_blank">14 virtual community sessions</a> 
      open to all, which encouraged participants from across our 
      island chain to offer proposal sketches for policy changes and action initiatives.
      </p>

      <p>
      Following those sessions, Consider.it enabled us to continue a meaningful, productive one-month 
      virtual conversation about improving Hawaiʻi’s future.
      With minimal guidance (a quick sharing of the Consider.it tutorial video), participants could 
      easily offer their general level of agreement or disagreement regarding each proposal, share 
      as many succinct pro/con comments as they wished regarding the proposals, read what 
      others had to say about the proposals, and adopt comments that resonated with them. 
      In real time, Consider.it created an intuitive pictorial graph of everyone’s level of 
      support for a proposal, along with the underlying reasoning.
      </p>


      <p>All told, these Consider.it discussions involved 
      nearly 500 participants who offered over 3,250 assessments of 192 proposals. Consider.it was the ideal tool 
      for us to facilitate this level of engagement. Anyone hoping to coordinate a community-wide conversation in a 
      way that’s easy for participants and productive for organizers would greatly benefit from 
      including Consider.it in their process. 
      </p>

      <p>
      Furthermore, <a href="https://ainaalohafutures.consider.it" target="_blank">the Consider.it record</a> of the robust online conversation we held has proven invaluable. We were able to develop a 
      <a href="https://docs.google.com/document/d/1GJdVPM84fA0x9UBGpii0UjBgvEiV4INr2ES5FXmRpjk/edit" target="_blank">Policy Playbook</a> 
      that spotlighted salient points raised through the proposals and the Consider.it discussion of them. It helped AAEF garner 
      <a href="https://docs.google.com/spreadsheets/d/1WNkdsyhd-whH58dE-6819oFmVVHur0c0V41Rl7fL33E/edit#gid=0" target="_blank">many additional signatories</a> 
      supporting the effort, including three of four county mayors, three of four county councils, the largest private landowner 
      in Hawai’i (Kamehameha Schools), the state government agency charged with overseeing Hawaiʻi’s visitor industry 
      (Hawai’i Tourism Authority), and the University of Hawaiʻi John A. Burns School of Medicine.
      </p>


      <p>
      Hawai’i state and county policy makers who each received a copy of the Playbook could readily see in our Consider.it 
      record that a large community of engaged participants collectively arrived at the proposals offered in it, 
      affording the Playbook a significant degree of impact. While AAEF did not actively lead the way in specific legislative 
      bills this session, the overall momentum the AAEF Consider.it results produced played a contributing role in 
      the passage of bills relating to climate change mitigation, sustainable agriculture, raising the minimum wage, 
      and protections for traditional water rights. 
      </p>

      <p>The Consider.it team has consistently exceeded all our expectations. Travis was 
      always quick to reply to questions and requests and has always gone the extra mile to 
      help us make the most of the amazing suite of tools that Consider.it offers. He has 
      even regularly reached out to provide us options we didn’t even realize were possible.</p> 
      <p>It’s clear that Consider.it’s ability to raise up community voices means a lot to 
      Travis and the Consider.it team. ‘Āina Aloha Economic Futures most deeply appreciates 
      all that Consider.it, Travis, and his team have done to support our initiative.
      </p>      


    """



  susie:
    alt: "Susie Philipsen uses Consider.it to help foster public engagement on behalf of the City of Seattle."
    name: 'Susie Philipsen' 
    role: "Senior Public Relations Specialist"
    organization: "City of Seattle"
    avatar: asset('product_page/susie.png')


    short_quote: """
      <p>Working with the Consider.it team on 
      <a style="font-weight: 400; text-decoration: none;" href="https://hala.consider.it" target="_blank">Seattle’s dialogue about Housing Affordability</a> 
      has been a fantastic experience!</p>

      <p><b>We’ve created a great feedback loop with residents 
      via Consider.it. Residents are acknowledging the information we are providing them, 
      learning from it, and even thanking us.</b></p>

      <p>If you’re looking to create quality online 
      dialogues, Consider.it is an excellent choice. They bring far more to the table than technical skills 
      – they think deeply about how the tool is going to be received and help us build a 
      better dialogue using that knowledge.</p>
      """

    long_quote: """
        <p>Working with the Consider.it team on <a href='https://hala.consider.it'>Seattle’s dialogue about Housing Affordability</a> has been a fantastic experience. They bring far more to the table than technical skills – they think deeply about how the tool is going to be received and help us build a better dialogue using that knowledge. Furthermore, the Consider.it team is very responsive - the back and forth communication has been very easy.</p> 

        <p>We’ve created a great feedback loop with residents 
        via Consider.it. Residents are acknowledging the information we are providing them, 
        learning from it, and even thanking us.</p>


        <p>Some of the ways the Consider.it team helped our team include:</p>

        <ul>
        <li><strong>Framing content for a general audience</strong>. We spent a lot of time writing technically correct questions, but the Consider.it team helped us recognize how difficult these questions are to understand. They helped us refine all the content. This included setting expectations about how residents’ feedback fits into the larger process. </li>

        <li><strong>Translating our needs into a good digital experience</strong>. Being new to online dialogue, the consider.it team helped us focus our goals for information gathering. We wanted to collect demographic information so we could assess outreach effectiveness. We collaborated to identify the minimal information to collect from residents to answer critical questions.</li>

        <li><strong>Outreach and recruitment</strong>. The consider.it team helps us understand which populations are providing feedback. I can then focus our online advertising on recruiting people from underrepresented neighborhoods and groups.</li>

        <li><strong>How to engage with residents</strong>. The team encouraged us to engage directly with residents by responding to questions and concerns online. This support made me more proactive in answering questions. When I don’t know the answer, I reach out to the technical experts and ask them to respond that day so we can keep the conversation going. Residents are acknowledging the information we are providing them, learning from it, and even thanking us.</li>

        </ul>
        <p>If you’re looking to create quality online dialogues, Consider.it is an excellent choice.</p>
        """

  russ: 
    alt: "Russ Lehman uses Consider.it to engage in participatory strategic planning in his non-profit organization."
    name: 'Russ Lehman' 
    role: "Executive Director"
    organization: "WSFFN"
    avatar: asset('product_page/Russ.png')

    # short_quote: """I was nervous about getting our board members and wider network on the same page about a 
    #                 pressing strategic change. The Consider.it team rescued us! They structured a quick 
    #                 Consider.it dialogue with all our stakeholders that gave legitimacy and momentum to 
    #                 our new direction, without the hassle of bringing everyone together physically."""
    short_quote: """
        <p>
        When we embarked on rebranding, I was daunted with the task of engaging constituents across the state. 
        As a small non-profit, we didn’t have the funds to reach everyone in-person. With Consider.it, we 
        could engage far more people for a cost we could afford.
        </p>

        <p>
        Beyond the great tool, the Consider.it team was incredibly knowledgeable, creative, thoughtful, and 
        available in helping craft an engagement strategy. They helped us structure a lightweight dialogue 
        with all our stakeholders.</p>

        <p><b>
        We got legitimacy and momentum for our new direction, without the 
        hassle of bringing everyone together physically.
        </b></p>    """
    long_quote: """
        <p>
        When we embarked on rebranding, I was daunted with the task of engaging constituents across the state. 
        As a small non-profit, we didn’t have the funds to reach everyone in-person. With Consider.it, we 
        could engage far more people for a cost we could afford.
        </p>

        <p>
        Beyond the great tool, the Consider.it team was incredibly knowledgeable, creative, thoughtful, and 
        available in helping craft an engagement strategy. They helped us structure a lightweight dialogue 
        with all our stakeholders.</p>

        <p>
        We got legitimacy and momentum for our new direction, without the 
        hassle of bringing everyone together physically.
        </p>

        <p>Some of the ways the Consider.it team helped us include:</p>

        <ul>
        <li><strong>Creation of questions</strong> to yield the most valuable information.</li>

        <li><strong>Designing a multi-phase process</strong> that first used Consider.it to engage our statewide stakeholders, then to discuss results with our board and eventually leading to a board vote at our annual retreat.</li>

        <li><strong>Advice on how to interact with stakeholders</strong> to yield even more substantive results and maintain civil discourse.</li>

        <li><strong>Interpretation of responses</strong> to gain deeper insight and assist with reporting lessons back to our board and stakeholders.</li>

        </ul>
        """

  pierre: 
    alt: "Pierre-Elouan Réthoré uses Consider.it to help make decisions in his co-housing community."
    name: 'Pierre-Elouan Réthoré, Ph.D.' 
    role: 'Senior Researcher'
    organization: "Danish Technical University"
    avatar: asset('product_page/pierre.png')

    short_quote: """
                 We had a nearly 50/50 deadlocked split in our housing community. <b>After we started using Consider.it, 
                 people could clearly express the reasons behind their opinions, and see other’s reasons. We were able 
                 to work out a compromise.</b> That’s the first time where I felt like democracy was actually working.
                 """

  auryn: 
    alt: "Auryn Macmillan uses Consider.it for community ideation and decision making in large decentralized online communities."
    name: 'Auryn Macmillan' 
    role: 'Co-founder'
    organization: "DAOhub"
    avatar: asset('product_page/auryn.png')

    short_quote: """
                 Consider.it’s careful design choices were critical for not only aggregating 
                 community opinions, but also in understanding the 
                 rationale. <b>The ability to get a feel for both the gestalt and the 
                 granular details of an issue within the one view is an incredible 
                 achievement</b> and was a vital part of our community’s decision making 
                 process.
                 """

    long_quote: """

        <p>
        At DAOhub, a group of volunteers came together to create a home for the communities of a radical new 
        form of human interaction, Decentralised Autonomous Organisations (or DAOs for short). We set 
        up a <a href='http://discourse.org' target="_blank">Discourse</a> forum to act as our base 
        means of communication. However one of the major challenges we faced was effectively 
        aggregating community sentiment on issues and proposals. This was vital for the DAO to 
        function properly. The simple polls that ship with Discourse were somewhat limited and 
        did not quite fulfill the need.</p>

        <p>
        Luckily, Consider.it beats the hell out of simple polls! It is a fantastic tool for gauging 
        the opinion of a large number of users, while not losing sight of the individuals.</p>

        <p>
        Consider.it’s careful design choices were instrumental for us not only in terms of aggregating 
        community opinions, but also in picking out the rationale behind community member opinions. 
        This ability to get a feel for both the gestalt and the granular details of an issue within 
        the one view is an incredible achievement and was a vital part in our community’s decision making process.
        </p>

        <p>If effectively gauging the opinion/sentiment of your community is something that is important 
        or necessary for your business/product/community, then the team at Consider.it would be an 
        invaluable partner. Their product and advice is second to none. Seriously, these 
        guys are flat out awesome. Incredibly responsive and receptive to suggestions, and, 
        as is evident by the nuance of their platform, they really have a fantastic grasp 
        on the needs of web based and decentralised communities.</p>
        """

  sheri: 
    alt: "Sheri Richardson helped us evaluate whether our efforts to make Consider.it accessible was successful."
    name: 'Sheri Richardson'
    role: 'President'
    organization: 'Guide Dog Users of WA State'
    # name: ''
    # role: 'Sheri Richardson, President, Guide Dog Users of WA State'
    # organization: ''

    # short_quote: """I am blind and use assistive technology to read information on a computer screen. 
    #                 Consider.it works well with my screen reading software and allows me the opportunity 
    #                 to fully participate in my city’s decision making process in the same way all others 
    #                 can! <strong>I appreciate Consider.it’s hard work making their website fully accessible to me 
    #                 and other blind computer users.</strong>"""
    short_quote: """Consider.it works well with my screen reading software and allows me the 
                    opportunity to fully participate in the same way all others can. 
                    <strong>I appreciate Consider.it’s hard work making their website fully accessible to me 
                    and other blind computer users.</strong>"""


testimonials.susie_pricing = _.extend {}, testimonials.susie, 
  short_quote: """They bring far more to the table than technical skills – their team thinks deeply about how Consider.it is going to be received and helped us build a better public dialogue using that knowledge, such as by:<ul><li>framing content for a general audience</li><li>teaching best practices for engaging residents</li><li>creating new features to support our use case</li></ul>"""

testimonials.auryn_pricing = _.extend {}, testimonials.auryn, 
  short_quote: """The Consider.it team is incredibly receptive to suggestions, and, as is evident 
                  by the nuance of their platform, they really have a fantastic grasp on the needs 
                  of web based and decentralised communities. They:<ul><li>helped restructure our 
                  organizational processes</li><li>designed a custom forum homepage</li><li>created 
                  a rich custom embed of consider.it</li></ul>"""


testimonials.russ_pricing = _.extend {}, testimonials.russ, 
  short_quote: """Beyond the great tool, the Consider.it team was extremely knowledgeable and available in helping craft an engagement strategy. They helped us:<ul><li>create clear, valuable questions</li><li>design a multi-phase engagement process</li><li>improve interactions with our network</li><li>interpret responses</li></ul>"""

testimonials.kehau_example = _.extend {}, testimonials.kehau,
  short_quote: """<p>The Consider.it team has consistently exceeded all our expectations. Travis was 
                  always quick to reply to questions and requests and has always gone the extra mile to 
                  help us make the most of the amazing suite of tools that Consider.it offers. He has 
                  even regularly reached out to provide us options we didn’t even realize were possible.</p> 
                  <p>It’s clear that Consider.it’s ability to raise up community voices means a lot to 
                  Travis and the Consider.it team. ‘Āina Aloha Economic Futures most deeply appreciates 
                  all that Consider.it, Travis, and his team have done to support our initiative.</p>"""

delete testimonials.kehau_example.long_quote


/** WEBPACK FOOTER **
 ** ../wwwconsiderit/@client/product_page/testimonials.coffee
 **/